module.exports = __webpack_public_path__ + "static/media/helper_icon.6827a8a5.svg";